import React from 'react';
// Scholarships & Awards Notification
const FifteenStepWhatsappTemplate = ({ values }) => {
  // console.log('✌️values --->', values);
  const {
    client_name,
    conference_short_name,
    deadline_date,
    scholarship_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>
        <strong>
          {conference_short_name ? conference_short_name : `[Conf Short Name]`}
        </strong>{' '}
        is offering scholarship opportunities for our upcoming event! 🎓 You can
        avail up to 40% off the registration fee for in-person attendance, or a
        20% discount for virtual participation. Additionally, one outstanding
        participant will be awarded a full scholarship!
      </p>

      <p>
        Don’t miss this opportunity to gain recognition and network with
        industry leaders. Apply for the scholarship by{' '}
        <strong>{deadline_date ? deadline_date : `[Deadline Date]`}</strong>{' '}
        here:{' '}
        {scholarship_link ? (
          <a href={scholarship_link} target="_blank" rel="noopener noreferrer">
            
            {scholarship_link}
          </a>
        ) : (
          `[Scholarship Link]`
        )}
        .
      </p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default FifteenStepWhatsappTemplate;
